import { FirebaseApp } from "./firebase";

export const loginAnonymously = () => {
  FirebaseApp.auth.signInAnonymously().catch((e) => {
    console.error(e);
  });
};
